// extracted by mini-css-extract-plugin
module.exports = {"background":"Error_background__GoCW_"};